import { render, staticRenderFns } from "./ProjectSummary.vue?vue&type=template&id=b6cc0cb6"
import script from "./ProjectSummary.vue?vue&type=script&lang=js"
export * from "./ProjectSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports